import { forwardRef } from 'react';
import { ScrollUpButtonProps } from '../types';

import styles from './styles.css';

export const ScrollUpButton = forwardRef<HTMLButtonElement, ScrollUpButtonProps>(
  ({ icon: Icon, onClick, testId }, ref) => (
    <button ref={ref} className={styles['root']} onClick={onClick} data-testid={testId}>
      <Icon color={'icon-inverted-default'} />
    </button>
  ),
);

ScrollUpButton.displayName = 'ScrollUpButton';
